export default __webpack_public_path__ + "static/media/02.897c9200.png";